/**
 * Shared shelf types — the template-layer vocabulary SKIN resolver contract.
 *
 * The 5 entity shelves (Plan/Design/Execute/Verify/Govern) receive their label
 * resolver from ShelfSidebar, which calls useTemplateLabels(projectId) ONCE so
 * there is a single deduped fetch for the whole sidebar (react-query keyed on
 * projectId). A shelf rendered in isolation (or outside a project) defaults to
 * IDENTITY_SHELF_LABEL, which returns each card's verbatim current word — zero
 * visible change for a non-template project.
 */

import type { LabelResolver } from "@/hooks/useTemplateLabels";

/** The resolver a shelf uses to skin an entity-type card label. */
export type ShelfLabelResolver = LabelResolver;

/**
 * Canonical-only resolver: no manifest, so return the surface fallback (the
 * card's current word) verbatim. Used as the default when ShelfSidebar has not
 * threaded a real resolver (e.g. a shelf mounted in a unit test).
 */
export const IDENTITY_SHELF_LABEL: ShelfLabelResolver = (_type, opts) =>
  opts?.fallback ?? "";
